import React,{ useState, useEffect } from 'react';

import { PlusOutlined, ArrowUpOutlined, CloseOutlined, MinusOutlined } from '@ant-design/icons';

import humanBodyImg from '../../image/humanBodyImg.avif'

import './HumanBody.less'

const HumanBody = ({humanBodyData}) =>{
  const [width, setWidth] = useState(window.innerWidth);
  const [activeBtn, setActiveBtn] = useState('')
  const [openExpand, setEpenExpand] = useState(false)

  const btnList = [{
    name: '大脑',
    style: {top: '3%',left: '50%'},
    content: '人类大脑消耗了人体约25%的代谢能量，且对衰老过程尤为敏感。越来越多的科学家正在研究线粒体对大脑健康的影响，初步研究表明它们可能是大脑疾病的潜在关键因素。',
    expand: [
      {content:'Grimm，A.和Eckert，A.（2017），脑衰老和神经变性：从线粒体的角度。J.神经化学。 143: 418-431 ',link:'https://doi.org/10.1111/jnc.14037'},
      {content:'Fang et al. (2019).线粒体吞噬抑制淀粉样蛋白-β和tau病理，并逆转阿尔茨海默病模型中的认知缺陷。自然神经科学，22（3），401-412。',link:'https://doi.org/10.1038/s41593-018-0332-9'},
    ],
  },{
    name: '皮肤',
    style: {top: '14%',left: '47%'},
    content: '皮肤是我们最大的器官，也是与世界的接口，需要大量的能量来对抗衰老，线粒体提供了这种能量。随着年龄的增长，功能失调的线粒体会导致能量产生减少、细胞衰退，以及松弛、暗沉、皱纹和皮肤屏障减弱等衰老迹象。这会影响我们的整体健康。我们的临床研究表明，线粒体功能增强，改善皮肤细胞能量、年轻度、弹性和整体健康。',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  },{
    name: '免疫系统',
    style: {top: '30.5%',left: '51%'},
    content: '免疫系统保护我们免受感染和过度炎症。随着年龄的增长，它的控制会放松。越来越多的证据表明线粒体在减少衰老引起的炎症（也称为炎症性衰老）方面的重要性。',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  },{
    name: '关节',
    style: {top: '34%',left: '60.5%'},
    content: '关节是我们活动能力的关键。维持关节功能所需的细胞功能逐渐下降，线粒体也是如此。这些能量库需要更新和滋养，以保持关节健康。关于线粒体和关节炎之间的联系，正在出现新的科学。',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  },{
    name: '心脏',
    style: {top: '23%',left: '68%'},
    content: '2018年的一份报告回顾了最近的证据，表明线粒体功能障碍与心力衰竭的发展有关。“线粒体中的氧化代谢是心脏的主要能量来源，长期以来，无法产生和转移能量一直被认为是连接线粒体功能障碍和收缩衰竭的主要机制。”',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  },{
    name: '消化系统',
    style: {top: '53%',left: '67%'},
    content: '消化系统对人类健康至关重要。线粒体健康与改善肠道屏障健康、降低脂肪肝风险、改善肾功能和降低葡萄糖不耐受风险有关。',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  },{
    name: '骨骼肌',
    style: {top: '69%',left: '51.5%'},
    content: '在剧烈运动中，骨骼肌的能量消耗率几乎可以立即增加100倍以上。为了满足这种能量需求，肌肉细胞含有线粒体。我们的临床研究表明，线粒体功能的改善提高了肌肉力量和耐力。',
    expand: [{content:'Bo Zhou, Rong Tian. (2018). Mitochondrial dysfunction in pathophysiology of heart failure. J Clin Invest. 2018;128(9):3716-3726. ',link:'https://doi.org/10.1172/JCI120849'}],
  }]


  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])



  if(width > 770){
    return (
      <div className="HumanBody-box">
        {/* 标题 + 详情 | 展开详情 */}
        {activeBtn? 
          <div className="activeBtn-content" style={{width: '45%'}}>
            <div className="title">
              {activeBtn} 
              <div 
                style={{corsor:'pointer'}} 
                onClick={()=>{
                  setActiveBtn('')
                  setEpenExpand(false)
                }}
              >
                <CloseOutlined />
              </div>
            </div>
            <div className="context">{btnList.filter(e=> e.name === activeBtn)[0].content}</div>
            <div className="expand" onClick={()=>setEpenExpand(!openExpand)}>
              科学研究
              <div style={{cursor:'pointer'}}>
                {openExpand? 
                  <MinusOutlined />
                  :
                  <PlusOutlined />
                }
              </div>
            </div>
            {openExpand? <div className="expand-content">
              {btnList.filter(e=> e.name === activeBtn)[0].expand.map((e,i)=>{
                return (
                  <div key={i} className="item">
                    {e.content}
                    <a href={e.link}>{e.link}</a>
                    <ArrowUpOutlined style={{transform: 'rotate(45deg)',color: 'rgba(0, 0, 0, 0.54)'}} />
                  </div>
                )
              })}
            </div>:''}
            
          </div>
          :
          <div className="HumanBody-content-box" style={{width: 500, right: 50}}>
            <div className="title">
              线粒体是健康的基石
            </div>
            <div className="description">
              健康的细胞依赖于健康的线粒体。它们的最佳功能可以带来令人难以置信的健康益处，对心脏、肾脏、眼睛、大脑、皮肤和肌肉功能尤其重要。迄今为止，我们的临床科学一直专注于肌肉健康，因为肌肉细胞有大量的线粒体，以及作为我们身体最大器官的皮肤健康。
            </div>
          </div>
        }
        
        
        {/* 图片 + 按钮 */}
        <div className="humanBodyImg-box" style={{width: '50%'}}>
          <img src={humanBodyImg} alt="" />
          {btnList.map((e)=>{
            return (<div 
              key={e.name} 
              className='btn-box' 
              style={{...e.style, position:'absolute'}} 
              onClick={()=> {
                setActiveBtn(e.name)
                setEpenExpand(() => false)
              }}
            >
              <div className={activeBtn === e.name? 'btn btn-active':'btn'}>
                <PlusOutlined style={activeBtn === e.name? {fontSize: 20,color:'#fff'}:{fontSize: 20,color:'#000'}}/>
              </div>
              <div className="hoverName">{e.name}</div>
            </div>)
          })}
        </div>
      </div>
    )
  }else{
    return (
      <div className="HumanBody-box-phone">
        {/* 标题 + 详情 */}
        <div 
          className="HumanBody-content-box" 
          style={{ right: 50, marginTop: 20 }}
        >
          <div className="title">
            线粒体是健康的基石
          </div>
          <div className="description" style={{marginTop: 20}}>
            健康的细胞依赖于健康的线粒体。它们的最佳功能可以带来令人难以置信的健康益处，对心脏、肾脏、眼睛、大脑、皮肤和肌肉功能尤其重要。迄今为止，我们的临床科学一直专注于肌肉健康，因为肌肉细胞有大量的线粒体，以及作为我们身体最大器官的皮肤健康。
          </div>
        </div>

        {/* 图片 + 按钮 */}
        <div className="humanBodyImg-box">
          <img src={humanBodyImg} alt="" />
          {btnList.map((e,i)=>{
            console.log()
            return (<div 
              key={e.name} 
              className='btn-box' 
              style={{...e.style, position:'absolute'}} 
              onClick={()=>{ 
                setActiveBtn(e.name)
                setEpenExpand(() => false)
              }}
            >
              <div className={activeBtn === e.name? 'btn btn-active':'btn'}>
                <PlusOutlined style={activeBtn === e.name? {fontSize: 20,color:'#fff'}:{fontSize: 20,color:'#000'}}/>
              </div>
              <div className="hoverName">{e.name}</div>
            </div>)
          })}
        </div>

        {/* 展开详情 */}
        {activeBtn? 
          <div className="activeBtn-content">
            <div className="title">
              {activeBtn} 
              <div 
                style={{corsor:'pointer'}} 
                onClick={()=>{
                  setActiveBtn('')
                  setEpenExpand(false)
                }}
              >
                <CloseOutlined />
              </div>
            </div>
            <div className="context">{btnList.filter(e=> e.name === activeBtn)[0].content}</div>
            <div className="expand" onClick={()=>setEpenExpand(!openExpand)}>
              科学研究
              <div style={{cursor:'pointer'}}>
                {openExpand? 
                  <MinusOutlined />
                  :
                  <PlusOutlined />
                }
              </div>
            </div>
            {openExpand? <div className="expand-content">
              {btnList.filter(e=> e.name === activeBtn)[0].expand.map((e,i)=>{
                return (
                  <div className="item">
                    {e.content}
                    <a href={e.link}>{e.link}</a>
                    <ArrowUpOutlined style={{transform: 'rotate(45deg)',color: 'rgba(0, 0, 0, 0.54)'}} />
                  </div>
                )
              })}
            </div>:''}
            
          </div>
          :
          ''
        }
      </div>
    )
  }
}

export default HumanBody